import {defaultKeywords} from "../keywords";

export const seoContentMapZh = {
    '/': {
        title: "Rodin - 免费 AI 3D 模型生成器，从图像轻松创建 3D 模型 | Hyper3D",
        description: "只需数秒即可利用AI创建令人惊艳的3D模型。无论是基于文本还是图像，都能轻松生成3D模型，助力您快速变革创意流程。",
        keywords: defaultKeywords,
        h1Text: "Rodin - 免费AI 3D模型生成器（文本 & 图像）",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin - 免费 AI 3D 模型生成器 | Hyper3D",
        description: "只需数秒即可利用AI创建令人惊艳的3D模型。通过文本或图像快速生成，彻底革新您的创意流程！",
        keywords: defaultKeywords,
        h1Text: "Rodin - 免费AI 3D模型生成器（文本 & 图像）",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin - AI 3D 模型生成器",
        description: "只需数秒即可利用AI创建令人惊艳的3D模型。通过文本或图像快速生成，彻底革新您的创意流程！",
        keywords: defaultKeywords,
        h1Text: "Rodin - 免费AI 3D模型生成器（文本 & 图像）",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式"
    },
    '/rodin/search': {
        title: "3D 模型资源 | Hyper3D",
        description: "支持在线查看3D模型并免费下载为 fbx、obj、glb、usd 等格式。模型适用于游戏、VR/AR、视频制作和3D打印场景。",
        keywords: defaultKeywords,
        h1Text: "Rodin - 免费AI 3D模型生成器（文本 & 图像）",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式"
    },
    '/rodin/tab/story': {
        title: "Rodin - 用户故事精选 | Hyper3D",
        description: "探索各类用户故事，了解 Rodin 如何改变艺术家和设计师的创作流程。",
        keywords: defaultKeywords,
        h1Text: "Rodin - 免费AI 3D模型生成器（文本 & 图像）",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar - AI 3D 面部资产生成器 | Hyper3D",
        description: "ChatAvatar by Hyper3D 可在数分钟内根据文本或图像自动生成具备PBR贴图、逼真的3D面部资产。",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3D面部资产生成器",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar - AI 3D 面部资产生成器 | Hyper3D",
        description: "ChatAvatar by Deemos Hyper3D 可在数分钟内根据文本或图像自动生成具备PBR贴图、逼真的3D面部资产。",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3D面部资产生成器",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "价格与订阅 | Hyper3D",
        description: "订阅 Hyper3D，获取专属功能和内容，助您提升创作效率与品质。",
        keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
        h1Text: "订阅 - Hyper3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "API 控制台 | Hyper3D",
        description: "管理您的 Hyper3D API Key 并监控使用情况，轻松掌控数据与服务。",
        keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
        h1Text: "API 控制台",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "登录 | Hyper3D",
        description: "登录您的 Hyper3D 账户。免费试用，轻松体验。让 Hyper3D 帮助您在建模、贴图等方面更高效。",
        keywords: defaultKeywords + "Login, Hyper3D, User, Account",
        h1Text: "登录",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "注册 | Hyper3D",
        description: "创建全新的 Hyper3D 账户。免费试用，轻松上手。让 Hyper3D 帮助您在建模、贴图等方面更高效。",
        keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
        h1Text: "注册",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "隐私政策 | Hyper3D",
        description: "阅读 Hyper3D 隐私政策，了解我们如何处理和保护您的个人数据。",
        keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
        h1Text: "隐私政策",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "服务条款 | Hyper3D",
        description: "阅读 Hyper3D 的服务条款及使用条件，这些条款规范了通过 Hyper3D 所进行的各项创作。",
        keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
        h1Text: "服务条款",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "常见问题 | Hyper3D",
        description: "查阅常见问题，快速了解 Hyper3D 产品及服务的更多信息。",
        keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
        h1Text: "常见问题",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft - 3D工具箱 | Hyper3D",
        description: "Omnicraft 是一款免费的在线3D建模工具箱，适用于3D艺术家、游戏开发者、设计师等多种人群。",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
        h1Text: "使用图像、文本与想象力创造您的虚拟世界",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "HDRI 全景生成器 - 创建你的虚拟世界 | Hyper3D",
        description: "只需数秒即可通过我们的 HDRI 全景生成器打造你的虚拟世界。支持图像、文本及更多创意方式。",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
        h1Text: "使用图像、文本与想象力创造您的虚拟世界",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "3D 格式转换器 - 免费且完全离线 | Hyper3D",
        description: "只需拖拽3D模型文件即可快速转换为 obj、fbx、gltf、glb、usd 等流行格式。免费使用，完全离线。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "免费、安全且完全离线的3D模型转换工具",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "3D 网格雕刻 - 免费且完全离线 | Hyper3D",
        description: "支持多种流行格式的3D网格雕刻工具，包括 obj、fbx、3ds、dxf、glb、usd 等。免费使用，完全离线。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "免费、安全且完全离线的3D模型转换工具",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin Search - 3D 模型搜索引擎 | Hyper3D",
        description: "一站式3D搜索引擎，可使用图像、文本或3D模型自身快速搜索Sketchfab、Daz3D及Rodin上的3D模型。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Rodin Search - 3D模型搜索引擎",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "3D 模型查看器 - 免费且完全离线 | Hyper3D",
        description: "支持多种流行格式（obj、fbx、stl、gltf、3ds、dxf、ply、glb、usd）的一体化3D查看器。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "免费、安全且完全离线的3D模型查看器",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "3D 贴图生成器 - 由图像生成3D贴图 | Hyper3D",
        description: "AI贴图生成器，让所有人都能通过图像快速为模型、游戏、AR/VR及艺术品赋予逼真的材质。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "免费、安全且完全离线的3D贴图生成器",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - 用 Rodin & ChatAvatar 颠覆3D建模方式",
        canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    }
}